export const popupModal = () => {
  const banner = document.querySelector('.hwg-modal');
  if (!banner) return false;
  const closeBanner = banner.querySelector('.hwg-modal-close');
  const state = sessionStorage.getItem('bannerDisabled');
  const links = banner.querySelectorAll('a[href^="http"]');
  localStorage.removeItem('bannerDisabled');

  function closeHandler() {
    document.body.classList.remove('js-modal-active');
    sessionStorage.setItem('bannerDisabled', true);
    banner.classList.add('js-disabled');
  }

  function openHandler() {
    document.body.classList.add('js-modal-active');
    banner.classList.remove('js-disabled');
    sessionStorage.removeItem('bannerDisabled');
  }

  if (state === undefined || state === null) {
    openHandler();
    closeBanner.addEventListener('click', closeHandler);
    if (links) {
      links.forEach((link) => {
        link.addEventListener('click', closeHandler);
      });
    }
  }
};
